const initialState = {
  total_pages: 1,
  current_page: 1,
  checkins: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_CHECKINS":
      return action.payload.checkins;
    case "UPDATE_CURRENT_PAGE":
      return {
        ...state,
        current_page: action.payload.currentPage
      }
    default:
      return state;
  }
}
